module.exports = __webpack_public_path__ + "img/travel-agency.78b153f6.png";